import { useCallback, useState } from 'react';
import { useRouter } from 'next/router';
import dynamic from 'next/dynamic';

import SvgIcon from '@picsart/rc/old/SvgIcon';
import useMount from '@picsart/rc/useMount';

import MobileMenu from '../MenuSidebar/MenuSidebar';
import Anchor from '~/components/Anchor/Anchor';

import useAnalytics from '~/services/AnalyticsService';
import BlogLink from '~/components/BlogLink/BlogLink';
import { getPagePathValue } from '~/utils/Helpers';
import { ANALYTICS } from '~/utils/Constants';

import useHeaderStyles from '../HeaderJSS';

const SearchForm = dynamic(() => import('../../SearchForm/SearchForm'), {
  ssr: false,
});

const { EVENT_NAME, SCREEN_NAMES, ACTION_BUTTON_VALUES } = ANALYTICS;

function MobileHeader() {
  const [isMenuVisible, setIsMenuVisible] = useState(false);
  const { sendEvent } = useAnalytics();
  const router = useRouter();

  const asPath = router.asPath.replace(router.basePath, '');

  const classes = useHeaderStyles();

  const handleMenuToggle = e => {
    e.stopPropagation();
    setIsMenuVisible(prev => !prev);
  };

  const closeSideMenu = () => {
    setIsMenuVisible(false);
  };

  useMount(() => {
    router.events.on('routeChangeComplete', closeSideMenu);

    return () => {
      router.events.off('routeChangeComplete', closeSideMenu);
    };
  });

  const analyticsPageClick = useCallback(
    action_button => {
      sendEvent(EVENT_NAME.pageClick, {
        screen_name: SCREEN_NAMES.blog,
        page_type: getPagePathValue(asPath),
        action_button,
      });
    },
    [sendEvent, asPath],
  );

  const homeClickHandler = useCallback(
    () => analyticsPageClick(ACTION_BUTTON_VALUES.picsart_home),
    [analyticsPageClick],
  );

  const blogClickHandler = useCallback(
    () => analyticsPageClick(ACTION_BUTTON_VALUES.blog_home),
    [analyticsPageClick],
  );
  SvgIcon.displayName = 'SvgIcon';

  return (
    <header className={classes.root}>
      <div className={classes.wrap}>
        <div className={classes.contentLeft}>
          <SvgIcon
            className={classes.mobileMenuIcon}
            onClick={handleMenuToggle}
            name="burger-gen"
          />
          {isMenuVisible && <MobileMenu closeMenu={handleMenuToggle} />}
          <div className={classes.contentLeft}>
            <Anchor
              data-test-home-click-handler
              className={classes.logoLink}
              onClick={homeClickHandler}
              href="/"
            >
              <img
                src="https://cdn140.picsart.com/28410169050081638995.svg"
                className={classes.logo}
                alt="Logo"
              />
            </Anchor>
            <BlogLink href={'/'} passHref>
              <Anchor
                className={classes.blogTitle}
                data-test-blog-click-handler
                onClick={blogClickHandler}
              >
                Blog
              </Anchor>
            </BlogLink>
          </div>
        </div>
        <div className={classes.contentRight}>
          <SearchForm />
        </div>
      </div>
    </header>
  );
}

export default MobileHeader;
